export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Viernes_banner.1aba1306.png";